import transformFileLists from 'utils/transformFileLists';
import { decamelizeKeys } from 'humps';

/**
 * Take some `formValues` and turn them into a `FormData` object ready to send.
 * @param {Object} formValues
 * @param {{dataKey:string}} config
 * @returns {FormData}
 */
const buildFormData = (formValues, config) => {
  const files = transformFileLists(formValues.fileAttachmentsAttributes);
  const formData = new FormData();
  files.forEach((file, idx) => {
    formData.append(`file_attachments_attributes[${idx}][document]`, file.document);
  });

  formData.append(config.dataKey, JSON.stringify(decamelizeKeys(formValues)));

  return formData;
};

export default buildFormData;
